
<v-flex>
    <v-progress-linear
        v-if="overlay && ! (!! user)"
        absolute
        indeterminate
    ></v-progress-linear>

    <card-collection
        :class="{ 'px-0-nested': (!! user) }"
        :meta="meta"
        :busy="overlay"
        @updated="updated"
    >
        <template #filters>
            <v-toolbar
                v-if="! (!! user)"
                elevation="0"
                color="transparent"
                class="mt-7"
                height="56"
            >
                <v-text-field
                    v-model="queries.search"
                    @click:clear="clearSearch"
                    class="input-search md mr-2"
                    clearable
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    :label="t('general_label_search')"
                ></v-text-field>

                <v-select
                    v-model="queries.statuses"
                    :items="statusItems"
                    class="md mr-2"
                    outlined
                    dense
                    append-icon="mdi-chevron-down"
                    hide-details
                    :label="t('main_goal_label_status')"
                ></v-select>

                <v-select
                    v-model="queries.type"
                    :items="typeItems"
                    class="md mr-2"
                    outlined
                    dense
                    append-icon="mdi-chevron-down"
                    hide-details
                    :label="t('main_goal_label_type')"
                ></v-select>

                <v-btn
                    @click="capture"
                    class="sm mx-5"
                    color="primary"
                >{{ t('general_action_search') }}</v-btn>

                <v-spacer></v-spacer>

                <v-btn
                    v-ripple="false"
                    plain
                    color="orange darken-4"
                    @click="reset"
                >{{ t('general_action_reset_filters') }}</v-btn>
            </v-toolbar>
        </template>

        <template #data>
            <thead>
            <tr>
                <th>{{ t('main_goal_label_id') }}</th>
                <th v-if="! (!! user)">{{ t('premium_label_user_id') }}</th>
                <th>{{ t('main_goal_label_title') }}</th>
                <th>{{ t('main_goal_label_type') }}</th>
                <th>{{ t('main_goal_label_plan_type') }}</th>
                <th>{{ t('main_goal_label_status') }}</th>
                <th>{{ t('main_goal_label_start_at') }}</th>
                <th>{{ t('main_goal_label_end_at') }}</th>
                <th>{{ t('main_goal_label_duration') }}</th>
                <th>{{ t('main_goal_label_program') }}</th>
                <th v-if="!! user"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="collection.data.length === 0">
                <td class="text-center" colspan="11">{{ t('general_text_no_data') }}</td>
            </tr>
            <template v-else v-for="goal in collection.data">
                <tr>
                    <td>
                        <a href="javascript:" @click.prevent="touch(goal)">{{ goal.id }}</a>
                    </td>
                    <td v-if="! (!! user)">
                        <router-link :to="{ name: 'trainees.show', params: { id: goal.userId }, query: { tab: '2' } }">
                            {{ goal.userId }}
                        </router-link>
                    </td>
                    <td>
                        <a href="javascript:" @click.prevent="touch(goal)">{{ goal.title }}</a>
                    </td>
                    <td>{{ mainGoalTypeTitle(goal.type) }}</td>
                    <td>{{ goal.planType ? planTypeTitle(goal.planType) : '-' }}</td>
                    <td>
                        <v-chip
                            small
                            :color="statusColor(goal.status)"
                            text-color="white"
                        >{{ mainGoalStatusTitle(goal.status) }}</v-chip>
                    </td>
                    <td>{{ goal.startAt ? goal.startAt.format('DD/MM/YYYY') : '-' }}</td>
                    <td>{{ goal.endAt ? goal.endAt.format('DD/MM/YYYY') : '-' }}</td>
                    <td>{{ goal.durationFormatted || '-' }}</td>
                    <td>{{ goal.program ? goal.program.name : '-' }}</td>
                    <td v-if="!! user" class="text-right">
                        <confirm-modal
                            :title="t('general_title_confirm_action')"
                            @agree="del(goal)"
                        >
                            <template #default="{ on, attrs }">
                                <v-btn
                                    icon
                                    small
                                    color="orange"
                                    v-on="on"
                                    v-bind="attrs"
                                ><v-icon small>mdi-delete-outline</v-icon></v-btn>
                            </template>
                        </confirm-modal>
                    </td>
                </tr>
            </template>
            </tbody>
        </template>
    </card-collection>
</v-flex>
